// @noflow
/* globals window */

/**
 * Get the streaming mode that Austin should be using
 * @returns {string} 'hls' or 'dash'
 */
const getStreamingMode = () => {
  if (/Safari/.test(window.navigator.userAgent) && /Apple Computer/.test(window.navigator.vendor)) {
    return 'hls';
  }
  return 'dash';
};

/**
 * Determine if HLS should be used for playback
 * @returns {boolean} is HLS
 */
export const isHlsMode = () => getStreamingMode() === 'hls';

/**
 * Parse query variables from window location
 * @returns {object} Parsed URL query variables
 */
export const getLocationQueryVars = () => {
  const vars = {};

  if (typeof window !== 'undefined' && window.location) {
    window.location.search.replace(/(?:^\??|&)([^&=]*)=?([^&]*)/g, (i, j, k) => {
      if (j) vars[j] = k;
    });
  }

  return vars;
};

/**
 * Get current platform
 * @returns {string} ios, android, or webd
 */
const getPlatform = () => {
  const { platform } = getLocationQueryVars();

  return platform || 'web';
};

/**
 * Get current platform
 * @returns {string} ios, android, or webd
 */
export const platform = getPlatform();

/**
 * Get debug enabled
 * @returns {bool} debug enabled
 */
const getDebug = () => {
  const { debug } = getLocationQueryVars();

  return !!debug;
};

/**
 * Get debug enabled
 * @returns {bool} debug enabled
 */
export const debug = getDebug();

export const appState = undefined;
